module.exports = __webpack_public_path__ + "img/14.17778e30.jpg";